import React, { useCallback, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import clsx from 'clsx'
import { PageLink, PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import { useParams } from 'react-router-dom';
import { Formatter, pegarEmpresaSelecionada, Periodo, Tipo } from "./Relatorio";
import { ICredito, IDebito, IDetalhesConciliado, } from '../../interfaces/IRelatorio';
import RelatoriosService from '../../services/RelatoriosService';
import { colorsToMatch } from '../../utils/Colors';
import * as XLSX from "xlsx";
import { saveAs } from 'file-saver';
import IconButton from '@material-ui/core/IconButton';
import { Collapse } from '@material-ui/core';

interface Column {
  id: string;
  label: string;
  width?: string;
  align?: "center" | "left" | "right";
}

function RowTable({ styles, creditos, debitos, columns, index }: { styles: any, creditos: any[], debitos: any[], columns: Column[], index: number }) {
  const [open, setOpen] = useState<boolean>(false);
  function funcaoClicar() {
    setOpen(!open);
  }

  return (
    <>
      <TableRow hover role="checkbox" tabIndex={-1} key={index} style={{ outline: '1px solid #A3A3A3' }}>
        <TableCell className={styles.cell} align='center' style={{ width: '10%' }}>
          <IconButton aria-label="expand row" size="small" onClick={funcaoClicar}>
            {
              open ?
                <i className="bi bi-arrow-up" style={{ color: '#525252' }} />
                :
                <i className="bi bi-arrow-down" style={{ color: '#525252' }} />
            }
          </IconButton>
        </TableCell>
        <TableCell style={{ width: '45%', textAlign: 'center' }}>
          {creditos.length > 0
            ? Formatter.format(creditos.map((item) => item['valor']).reduce((a, b) => a + b, 0))
            : Formatter.format(debitos.map((item) => item['valor']).reduce((a, b) => a + b, 0))}
        </TableCell>
        <TableCell style={{ width: '45%', textAlign: 'center' }}>
          {creditos.length > 0 ? creditos[0]['conta'] : (debitos.length > 0 ? debitos[0]['conta'] : 0)}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ border: 'none', padding: '0' }} colSpan={11}>
          <Collapse in={open} style={{ backgroundColor: '#EFF0F5', margin: '0.5px 0 1px 0', width: '100%' }} >
            <Table>
              <TableHead>
                {
                  creditos.map((item, index) =>
                    <TableRow style={{ outline: '1px solid #A3A3A3', border: 'none' }} key={index}>
                      <TableCell style={{ border: 'none' }}>
                        {item['dataString']}
                      </TableCell>
                      <TableCell style={{ border: 'none' }}>
                        {item['historico']}
                      </TableCell>
                      <TableCell>C</TableCell>
                      <TableCell style={{ border: 'none' }}>
                        {Formatter.format(item['valor'])}
                      </TableCell>
                      <TableCell style={{ border: 'none' }}>
                        {item['conta']}
                      </TableCell>
                    </TableRow>
                  )
                }
                {
                  debitos.map((item, index) =>
                    <TableRow style={{ outline: '1px solid #A3A3A3', border: 'none' }} key={index}>
                      <TableCell style={{ border: 'none' }}>
                        {item['dataString']}
                      </TableCell>
                      <TableCell style={{ border: 'none' }}>
                        {item['historico']}
                      </TableCell>
                      <TableCell>D</TableCell>
                      <TableCell style={{ border: 'none' }}>
                        {Formatter.format(item['valor'])}
                      </TableCell>
                      <TableCell style={{ border: 'none' }}>
                        {item['conta']}
                      </TableCell>
                    </TableRow>
                  )
                }
                <TableRow style={{ outline: '1px solid #A3A3A3', border: 'none' }} key={index}>
                  <TableCell style={{ border: 'none' }}>
                    Total Créditos: {Formatter.format(creditos.map((item) => item.valor).reduce((a, b) => a + b, 0))}
                  </TableCell>
                  <TableCell style={{ border: 'none' }}>
                    Total Débitos: {Formatter.format(debitos.map((item) => item.valor).reduce((a, b) => a + b, 0))}
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  )
}

function RelatorioConciliado() {

  const { id } = useParams<{ id: string }>();
  const { classes } = useLayout();
  const [carregado, setCarregado] = useState<boolean>(false);
  const [detalhesConciliado, setDetalhesConciliado] = useState<IDetalhesConciliado>();
  const [dataInicial, setDataInicial] = useState<Date>();
  const [dataFinal, setDataFinal] = useState<Date>();
  const [totalCreditos, setTotalCreditos] = useState<ICredito[]>();
  const [totalDebitos, setTotalDebitos] = useState<IDebito[]>();
  const [dadosExportar, setDadosExportar] = useState<any>();
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Clientes',
      path: '/relatorioSelecionarCliente',
      isSeparator: false,
      isActive: false
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false
    },
    {
      title: 'Relatório',
      path: `/relatorio/${id}`,
      isSeparator: false,
      isActive: false
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: true
    }
  ]
  const columns: Column[] = [
    { id: 'valor', label: 'Valor', width: '10%', align: 'center' },
    { id: 'conta', label: 'Conta Empresa', width: '24%', align: 'center' },
  ];
  const useStyles = makeStyles({
    root: {
      width: '100%'
    },
    container: {
      maxHeight: 600
    },
    cell: {
      fontSize: '0.750em',
      padding: '0.250em',
      height: '42px'
    },
    simbolo: {
      '& *': {
        color: '#008F4C',
        fontSize: '2rem'
      }
    }
  });
  const styles = useStyles();
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);

  useEffect(() => {
    function preCarregar() {
      try {
        const titulo = document.querySelectorAll("h1")[0];
        const estiloTitulo = titulo.getAttribute('style') + 'font-size: 16px';
        const pageTitle = document.querySelectorAll(".page-title")[0];
        const estiloPageTitle = (pageTitle.getAttribute('style') ?? "") + 'margin-right: 0 !important';

        titulo.setAttribute('style', estiloTitulo);
        pageTitle.setAttribute('style', estiloPageTitle);
      } catch {
        setTimeout(() => {
          preCarregar();
        }, 50);
      }
    }

    const jsonDataInicial = localStorage.getItem(`${Tipo.DataInicial}`) as "";
    const dataInicial = JSON.parse(jsonDataInicial) as Date | undefined;
    const jsonDataFinal = localStorage.getItem(`${Tipo.DataFinal}`) as "";
    const dataFinal = JSON.parse(jsonDataFinal) as Date | undefined;

    setDataInicial(dataInicial);
    setDataFinal(dataFinal);

    preCarregar();
  }, [])

  useEffect(() => {
    localStorage.setItem(`${Tipo.DataInicial}`, JSON.stringify(dataInicial));
  }, [dataInicial])

  useEffect(() => {
    localStorage.setItem(`${Tipo.DataFinal}`, JSON.stringify(dataFinal));
  }, [dataFinal])

  const imprimirRelatorioExcel = useCallback(() => {
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const dadosExportadosCredito = dadosExportar.filter((item: any) => item['Tipo'] === 'CRÉDITO');
    const dadosExportadosDebito = dadosExportar.filter((item: any) => item['Tipo'] === 'DÉBITO');
    const wsCredito = XLSX.utils.json_to_sheet(dadosExportadosCredito);
    const wsDebito = XLSX.utils.json_to_sheet(dadosExportadosDebito);
    const wb = { Sheets: { 'Créditos Conciliados': wsCredito, 'Débitos Conciliados': wsDebito }, SheetNames: ["Créditos Conciliados", "Débitos Conciliados"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    saveAs(data, `Relatorio-${Date.now()}` + fileExtension);
  }, [dadosExportar]);

  useEffect(() => {
    async function preCarregar() {
      setCarregado(false);

      const empresa = pegarEmpresaSelecionada();
      const jsonContaEmpresa = localStorage.getItem(`${Tipo.ContaEmpresa}`) as "";
      const contaEmpresa = JSON.parse(jsonContaEmpresa) as number | undefined;

      if (empresa && empresa.id !== 0 && dataInicial && dataFinal) {
        await RelatoriosService.detalhesConciliados(empresa.id, contaEmpresa || 0, dataInicial, dataFinal, x => {
          const { creditos, debitos } = x;

          let creditosNaoRepetidos = [] as ICredito[];
          creditos.forEach((item) => {
            if (!creditosNaoRepetidos.find((i) => i.chaveVinculo === item.chaveVinculo)) {
              creditosNaoRepetidos.push(item);
            }
          });

          let debitosNaoRepetidos = [] as ICredito[];
          debitos.forEach((item) => {
            if (!debitosNaoRepetidos.find((i) => i.chaveVinculo === item.chaveVinculo)) {
              debitosNaoRepetidos.push(item);
            }
          });

          setDetalhesConciliado({ creditos: creditosNaoRepetidos, debitos: debitosNaoRepetidos } as IDetalhesConciliado);

          setTotalCreditos(creditos);
          setTotalDebitos(debitos);

          console.log(debitos);

          setDadosExportar([...debitos.map(d => ({
            'Tipo': 'DÉBITO',
            'Data': d.dataString,
            'Histórico': d.historico,
            'Valor': d.valor,
            'Conta Empresa': d.conta,
            'Chave Conciliação': d.chaveVinculo
          })), ...creditos.map(c => ({
            'Tipo': 'CRÉDITO',
            'Data': c.dataString,
            'Histórico': c.historico,
            'Valor': c.valor,
            'Conta Empresa': c.conta,
            'Chave Conciliação': c.chaveVinculo
          }))])
        });
      }

      setCarregado(true);
    }

    setTimeout(() => {
      preCarregar();
    }, 1000);
  }, [id, dataInicial, dataFinal])

  function handleChangePage(event: unknown, newPage: number) {
    setPage(newPage);
  };

  function handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>) {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function acaoBotaoPeriodo(dataInicial: Date | undefined, dataFinal: Date | undefined) {
    setDataInicial(dataInicial);
    setDataFinal(dataFinal);
  }

  return <>
    <PageTitle pageBack={`/relatorio/${id}`} breadcrumbs={breadCrumbs}>{localStorage.getItem(`${Tipo.Conciliado}`)}</PageTitle>
    <label style={{ color: '#525252', fontWeight: 700, fontSize: '20px', marginBottom: '10px' }}>{dataInicial && dataFinal ? carregado ? detalhesConciliado ? `Conciliados encontrados (${detalhesConciliado.creditos.length})` : 'Não foi encontrado nenhuma conciliação para ser exibida' : 'Carregando...' : 'Preencha o campo Período e clique em buscar para carregar os dados'}</label>
    <div className='toolbar' id='kt_toolbar' style={{ padding: ' 0 10px' }}>
      <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex')} style={{ padding: '0' }}>
        <DefaultTitle />
        <Periodo imprimirRelatorioExcel={imprimirRelatorioExcel} dadosExportar={dadosExportar} dataInicio={dataInicial} dataFim={dataFinal} acaoBotaoBuscar={acaoBotaoPeriodo} empresaId={parseInt(id)} />
      </div>
    </div>

    {
      dataInicial && dataFinal && carregado && detalhesConciliado &&
      <>
        <div className="col-md-12" style={{ display: 'flex' }}>
          <div className="col-md-12">
            <label style={{ letterSpacing: '2px', fontSize: '16px' }}>Lançamento a crédito</label>
            <Paper className={styles.root} style={{ outline: '1px solid #A3A3A3' }}>
              <TableContainer className={styles.container}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow style={{ outline: '1px solid #A3A3A3' }}>
                      <TableCell></TableCell>
                      {
                        columns.map((column, index) =>
                          <TableCell key={index} className={styles.cell} align={column.align} style={{ width: column.width, color: '#5E6397', fontWeight: 700, backgroundColor: '#ffffff' }} >
                            {column.label}
                          </TableCell>)
                      }
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      detalhesConciliado.creditos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(
                        (row, index) =>
                          <RowTable key={index}
                            columns={columns}
                            creditos={totalCreditos?.filter((item) => item.chaveVinculo === row.chaveVinculo) || []}
                            debitos={[]}
                            index={index} styles={styles} />)
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </div>
        </div>


        <div className="col-md-12" style={{ display: 'flex' }}>
          <div className="col-md-12">
            <label style={{ letterSpacing: '2px', fontSize: '16px' }}>Lançamento a débito</label>
            <Paper className={styles.root} style={{ outline: '1px solid #A3A3A3' }}>
              <TableContainer className={styles.container}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow style={{ outline: '1px solid #A3A3A3' }}>
                      <TableCell></TableCell>
                      {
                        columns.map((column, index) =>
                          <TableCell key={index} className={styles.cell} align={column.align} style={{ width: column.width, color: '#5E6397', fontWeight: 700, backgroundColor: '#ffffff' }} >
                            {column.label}
                          </TableCell>)
                      }
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      detalhesConciliado.debitos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(
                        (row, index) =>
                          <RowTable key={index}
                            columns={columns}
                            creditos={[]}
                            debitos={totalDebitos?.filter((item) => item.chaveVinculo === row.chaveVinculo) || []}
                            index={index} styles={styles} />)
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </div>
        </div>

        <TablePagination rowsPerPageOptions={[]} component="div" count={detalhesConciliado.creditos.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />

        <div>
          {detalhesConciliado && (
            <>
              {totalCreditos && totalCreditos.length > 0 && <label style={{ letterSpacing: '2px', fontSize: '16px' }}>Total lançamento a crédito: <b>{totalCreditos.map((item) => item.valor).reduce((a, b) => a + b).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</b></label>}
              <br />
              {totalDebitos && totalDebitos.length > 0 && <label style={{ letterSpacing: '2px', fontSize: '16px' }}>Total lançamento a débito: <b>{totalDebitos.map((item) => item.valor).reduce((a, b) => a + b).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</b></label>}
            </>
          )}
        </div>
      </>
    }
  </>
};

export default RelatorioConciliado;